var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"one-cms-grid-image-component"},[(_vm.link)?_c('one-cms-grid-link',{attrs:{"link":_vm.link}},[_c('img',{attrs:{"src":_vm.img,"alt":_vm.alt ? _vm.alt : '',"loading":"lazy"}})]):_c('img',{attrs:{"src":_vm.img,"alt":_vm.alt ? _vm.alt : '',"loading":"lazy"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }